import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { App } from './App';
import './index.css';
import { isDev } from './api';
import { unregisterOldServiceWorkers } from './utils/unregisterOldServiceWorkers';
import { shieldInit } from 'react-easyrocket/shield';
import { IS_PWA } from 'react-easyrocket';
import { checkAndSetPwaBasename } from './utils/pwa';
import { smarticoInit } from './utils/smartico';
import { addVitePreloadErrorHandler } from './utils/preloadRetry';
import { smartlookInit, smartlookRecordNumbers } from './utils/smartlook';
import dayjs from 'dayjs';
import isToday from 'dayjs/plugin/isToday';
import utc from 'dayjs/plugin/utc';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import localeData from 'dayjs/plugin/localeData';
import 'dayjs/locale/fr';
import 'dayjs/locale/de';
import 'dayjs/locale/pl';
import 'dayjs/locale/ro';
import { handleMirrorsSwRegistration } from './utils/mirrorsSw';

dayjs.extend(localeData);
dayjs.extend(localizedFormat);
dayjs.extend(isToday);
dayjs.extend(utc);
dayjs.extend(customParseFormat);

unregisterOldServiceWorkers();
handleMirrorsSwRegistration(!isDev);
checkAndSetPwaBasename();
smarticoInit();
addVitePreloadErrorHandler();
shieldInit();
smartlookInit();
smartlookRecordNumbers();

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <BrowserRouter basename={IS_PWA ? '/pwa' : undefined}>
    <App />
  </BrowserRouter>
);
